export default {
    namespaced: true,
    state: {
        //未保存的新建工单信息-列表key value
        orders: {},
        //这里的值是跟表单里的值不同步（即用户改过的之后 这里不会变化，只有自研大模型返回数据会改变）
        //自研大模型返回的数据：智能填单
        orderAI: {
            caseContent: '',//诉求内容
            caseAccordTypeIds: [],//诉求归口
            caseAccordTypeNames: '',//诉求归口
            selectedUnitId: '',//承办单位
            selectedUnitName: '',//承办单位
        },
        hideOrderInfoRequired: false,
    },
    mutations: {
        setOrder(state, {key, value}) {
            //console.log('before setOrder', state.orders)
            state.orders[key] = value
            //console.log('after setOrder', state.orders)
        },
        removeOrder(state, {key}) {
            //console.log('before removeOrder', state.orders)
            delete state.orders[key]
            //console.log('after removeOrder', state.orders)
        },
        clearOrders(state) {
            state.orders = {}
        },

        setOrderAI(state, data) {
            //console.log('before setOrderAI', state.orderAI)
            state.orderAI = {...state.orderAI, ...data}
            //console.log('after setOrderAI', state.orderAI)
        },
        setHideOrderRequired(state, data) {
            state.hideOrderInfoRequired = data;
        },
    },
    actions: {
        setOrderAction({commit}, data) {
            commit('setOrder', data)
        },
        removeOrderAction({commit}, data) {
            commit('removeOrder', data)
        },
        clearOrdersAction({commit}, data) {
            commit('clearOrders', data)
        },

        setOrderAIAction({commit}, data) {
            commit('setOrderAI', data)
        },
        setHideOrderRequiredAction({commit}, data) {
            commit('setHideOrderRequired', data)
        },
    },
}
